
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Abc extends Vue {
  @Prop() readonly channel!: Record<string, unknown>

  get isAppleDevice (): boolean {
    return (
        this.$store.getters.ua.isMobile === true &&
        this.$store.getters.ua.device.search(/iPhone|iPad/) > -1
      ) ||
      (
        this.$store.getters.ua.isMobile === false &&
        this.$store.getters.ua.device.indexOf('Mac') > -1
      )
  }
}
